<template>
  <div
    ref="kt_acoes_nfe_modal"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_acoes_nfe_modal"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header bg-light p-3">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Nota Fiscal Eletrônica</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body">
          <div
            v-if="this.loadingAcoes"
            class="ms-7 mb-7"
            v-bind:data-kt-indicator="this.loadingAcoes ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              Aguarde, carregando...
              <span
                class="spinner-border spinner-border-sm align-middle ms-2"
              ></span>
            </span>
          </div>
          <div v-else class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <button
                @click="previsualizarNFe(this.faturamento)"
                type="button"
                class="btn btn-light-primary w-100"
                v-bind:data-kt-indicator="
                  this.loadingPreVisualizacao ? 'on' : 'off'
                "
              >
                <span class="indicator-progress">
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-1"
                  ></span>
                  Aguarde...
                </span>
                <span
                  class="svg-icon svg-icon-2"
                  v-if="!this.loadingPreVisualizacao"
                >
                  <inline-svg src="media/icons/duotune/general/gen005.svg" />
                  Pré-visualizar
                </span>
              </button>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <button
                v-if="this.transmitirGerenciadorNFe"
                @click="transmitirNota(this.faturamento)"
                type="button"
                :class="['btn btn-light-dark w-100']"
                :disabled="!this.permitirTransmissao"
              >
                <span class="svg-icon svg-icon-2">
                  <inline-svg src="media/icons/duotune/general/gen016.svg" />
                </span>
                Transmitir NF-e
              </button>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <button
                v-if="this.consultarGerenciadorNFe"
                @click="gerenciarNFe()"
                type="button"
                class="btn btn-light-info w-100"
              >
                <span class="svg-icon svg-icon-2">
                  <inline-svg src="media/icons/duotune/general/gen019.svg" />
                </span>
                Gerenciador da NF-e
              </button>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <button
                v-if="this.imprimirGerenciadorNFe"
                @click="imprimirNFe(this.faturamento)"
                type="button"
                class="btn btn-light-danger w-100"
                :disabled="this.permitirTransmissao"
                v-bind:data-kt-indicator="this.loadingImpressao ? 'on' : 'off'"
              >
                <span class="indicator-progress">
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-1"
                  ></span>
                  Aguarde...
                </span>
                <span class="svg-icon svg-icon-2" v-if="!this.loadingImpressao">
                  <i class="fas fa-print me-2 fs-4 p-0"></i>
                  Imprimir NF-e
                </span>
              </button>
            </div>
            <div
              @click="editarNota()"
              v-if="this.permitirEditar"
              class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <button type="button" class="btn btn-light-primary w-100">
                <span class="svg-icon svg-icon-2">
                  <inline-svg src="media/icons/duotune/art/art005.svg" />
                </span>
                Editar Nota
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalAcoesNFe'"
    :mensagem="this.mensagemLoading"
    v-if="this.loading === true"
  ></LoadingModal>
  <ErroNFeModal
    v-if="exibirModalErroNFe"
    :erroOriginal="this.erroOriginal"
    :erroFormatado="this.erroFormatado"
    @exibirModalErroNFe="modalErroNFe"
  ></ErroNFeModal>
  <ViewFilePDF
    v-if="exibirImpressaoPDF"
    :show="exibirImpressaoPDF"
    :documento="documentoImpressao"
    :dadosEmail="dadosEmail"
    @exibirModalImpressao="exibirModalImpressao"
  ></ViewFilePDF>
</template>

<script>
import { getOrCreateInstanceModal, hideModalId } from "@/core/helpers/dom";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import ErroNFeModal from "@/views/gerenciarnfe/ErroNFeModal.vue";
import ViewFilePDF from "@/components/modals/general/ViewFilePDF";
import { mapState } from "vuex";

export default {
  emits: [
    "exibirAcoesNFeModal",
    "confirmarAcoesNFeModal",
    "editarAcoesNFeModal",
  ],
  components: {
    LoadingModal,
    ErroNFeModal,
    ViewFilePDF,
  },
  props: {
    id: { type: Number, required: true, default: -1 },
    editar: { type: Boolean, required: false, default: false },
  },
  methods: {
    cancelar() {
      hideModal(this.$refs.kt_acoes_nfe_modal);
      this.$emit("exibirAcoesNFeModal", false);
    },
    gerenciarNFe() {
      hideModal(this.$refs.kt_acoes_nfe_modal);
      this.$emit("exibirAcoesNFeModal", false);
      this.$router.push("/movimentacao/gerenciarNFe/gerenciarnfe");
    },
    async transmitirNota(faturamento) {
      if (faturamento.status_nfe.toUpperCase() === "EM DIGITAÇÃO") {
        var alert = await Swal.fire({
          text: "Deseja transmitir a nota selecionada?",
          icon: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          customClass: {
            confirmButton: "btn fw-bold btn-primary",
            cancelButton: "btn fw-bold btn-danger",
          },
        });
        if (alert.isConfirmed) {
          try {
            this.erroOriginal = "";
            this.erroFormatado = "";

            this.loading = true;
            this.mensagemLoading = "Transmitindo a NF-e";
            await this.exibirModalLoading(true);

            let result = await this.$store.dispatch(
              "gerenciadorNFe/transmitirNota",
              faturamento.id
            );

            if (result.Success === true) {
              if (result.Data && result.Data.XMotivo) {
                let mensagem = result.Data.CStat + " - " + result.Data.XMotivo;

                await this.carregarDadosNota();
                this.$emit("confirmarAcoesNFeModal");
                await this.showSuccessAlert(mensagem);
              }
            } else {
              if (result.Data) {
                if (
                  result.Data.ProtNFe &&
                  result.Data.ProtNFe.length > 0 &&
                  result.Data.ProtNFe[0].InfProt
                ) {
                  let mensagem =
                    result.Data.ProtNFe[0].InfProt.CStat +
                    " - " +
                    result.Data.ProtNFe[0].InfProt.XMotivo;

                  await this.exibirMensagemErroSimplificada(mensagem);
                } else if (result.Data && result.Data.CStat) {
                  let mensagem =
                    result.Data.CStat + " - " + result.Data.XMotivo;
                  await this.exibirMensagemErroSimplificada(mensagem);
                } else {
                  await this.showInvalidAlert(result.Message);
                }
              } else {
                await this.showInvalidAlert(result.Message);
              }
            }
          } catch (error) {
            if (error.Message) {
              await this.showInvalidAlert(error.Message);
            } else {
              var mensagemFormatada = await this.$utils.formatarMensagem(error);
              if (mensagemFormatada !== "") {
                this.erroOriginal = error;
                this.erroFormatado = mensagemFormatada;
                this.exibirModalErroNFe = true;
                await this.modalErroNFe(true);
              }
            }
          }
          await this.exibirModalLoading(false);
          this.loading = false;
          this.mensagemLoading = "";
        }
      } else {
        await this.showInvalidAlert(
          "O status da nota indica que a mesma não está em digitação."
        );
      }
    },
    async showQuestionAlert(text) {
      return await Swal.fire({
        text: text,
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "ENTER - Sim",
        cancelButtonText: "ESC - Não",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showInvalidAlert(text) {
      await Swal.fire({
        text: text,
        icon: "warning",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-warning",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showSuccessAlert(text) {
      await Swal.fire({
        text: text,
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-success",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async exibirMensagemErroSimplificada(informacao) {
      this.erroOriginal = informacao;
      this.erroFormatado = [{ erroFormatado: informacao, tagErro: informacao }];
      this.exibirModalErroNFe = true;
      await this.modalErroNFe(true);
    },
    async modalErroNFe(exibir) {
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_erro_nfe");
        }, 100);
      } else {
        await new Promise(() =>
          setTimeout(hideModalId("kt_modal_erro_nfe"), 100)
        );
        this.exibirModalErroNFe = false;
      }
    },
    async exibirModalLoading(exibir) {
      if (exibir === true) {
        this.loading = true;
        await this.sleep(100);
        getOrCreateInstanceModal("loadingModalAcoesNFe");
      } else {
        await this.sleep(500);
        hideModalId("loadingModalAcoesNFe");
        await this.sleep(100);
        this.loading = false;
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async carregarDadosNota() {
      if (this.id > 0) {
        try {
          this.loadingAcoes = true;
          var retOdata = await this.$store.dispatch(
            "faturamento/getFaturamentoOData",
            "?$select=id,status_nfe&$expand=FaturamentoChaveNFe($select=chave_acesso)&$filter=id eq " +
              this.id
          );

          if (
            retOdata &&
            retOdata.value !== null &&
            retOdata.value.length > 0
          ) {
            this.faturamento = retOdata.value[0];

            if (this.faturamento.status_nfe.toUpperCase() === "EM DIGITAÇÃO") {
              this.permitirTransmissao = true;
              this.permitirEditar = true;
            } else {
              this.permitirTransmissao = false;
              this.permitirEditar = false;
            }
          }
        } catch (error) {
          console.log(error);
        }
        this.loadingAcoes = false;
      }
    },
    async editarNota() {
      hideModal(this.$refs.kt_acoes_nfe_modal);
      //this.$emit("exibirAcoesNFeModal", false);
      this.$emit("editarAcoesNFeModal", false);
    },
    async imprimirNFe(faturamento) {
      if (
        faturamento.status_nfe.toUpperCase() === "AUTORIZADA" ||
        faturamento.status_nfe.toUpperCase() === "IMPRESSA" ||
        faturamento.status_nfe.toUpperCase() === "CANCELADA"
      ) {
        try {
          this.loadingImpressao = true;
          this.documentoImpressao = [];
          this.dadosEmail = [];
          var response = await this.$store.dispatch(
            "gerenciadorNFe/imprimirNFe",
            faturamento.id
          );

          if (response.Success === true) {
            this.documentoImpressao = response.Data.pdfFile;
            this.exibirImpressaoPDF = true;

            let emails = [];
            if (response.Data.emails && response.Data.emails.length > 0) {
              response.Data.emails.forEach((e) => {
                if (e.email.length > 0) {
                  emails.push(e.email);
                }
              });
            }

            let blob = this.$utils.dataToBlob(response.Data.pdfFile);
            let pdf = [];
            let xml = [];

            await this.$utils.blobToBase64(blob).then((res) => {
              pdf = res;
            });

            if (response.Data.xml) {
              let blobXML = this.$utils.base64ToBlob(response.Data.xml);
              await this.$utils.blobToBase64(blobXML).then((res) => {
                xml = res;
              });
            }

            this.dadosEmail = await this.$utils.dadosEmailNFe(
              faturamento.FaturamentoChaveNFe.chave_acesso
            );
            this.dadosEmail.emails = emails;
            this.dadosEmail.anexosEmail = [
              { nome: "NFe.pdf", base64Arquivo: pdf },
              {
                nome: faturamento.FaturamentoChaveNFe.chave_acesso + ".xml",
                base64Arquivo: xml,
              },
            ];

            await this.exibirModalImpressao(true);
          } else {
            await Swal.fire({
              text: response.Message,
              icon: "warning",
              buttonsStyling: false,
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn fw-bold btn-warning",
              },
            });
          }
        } catch (error) {
          console.log(error);
          await Swal.fire({
            text: "Não foi possível imprimir a NF-e!",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn fw-bold btn-warning",
            },
          });
        }
        this.loadingImpressao = false;
      } else {
        await this.showInvalidAlert(
          "O status da nota indica que a mesma não está autorizada."
        );
      }
    },
    async previsualizarNFe(faturamento) {
      try {
        this.loadingPreVisualizacao = true;
        this.documentoImpressao = [];
        this.dadosEmail = [];
        var response = await this.$store.dispatch(
          "gerenciadorNFe/previsualizarNFe",
          faturamento.id
        );

        if (response.Success === true) {
          this.documentoImpressao = response.Data.pdfFile;
          this.exibirImpressaoPDF = true;

          let emails = [];
          if (response.Data.emails && response.Data.emails.length > 0) {
            response.Data.emails.forEach((e) => {
              if (e.email.length > 0) {
                emails.push(e.email);
              }
            });
          }

          let blob = this.$utils.dataToBlob(response.Data.pdfFile);
          let pdf = [];
          let xml = [];

          await this.$utils.blobToBase64(blob).then((res) => {
            pdf = res;
          });

          if (response.Data.xml) {
            let blobXML = this.$utils.base64ToBlob(response.Data.xml);
            await this.$utils.blobToBase64(blobXML).then((res) => {
              xml = res;
            });
          }

          this.dadosEmail = await this.$utils.dadosEmailNFe(faturamento.id);
          this.dadosEmail.emails = emails;
          this.dadosEmail.anexosEmail = [
            { nome: "NFe.pdf", base64Arquivo: pdf },
            {
              nome: faturamento.id + ".xml",
              base64Arquivo: xml,
            },
          ];

          await this.exibirModalImpressao(true);
        } else {
          await Swal.fire({
            text: response.Message,
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn fw-bold btn-warning",
            },
          });
        }
      } catch (error) {
        console.log(error);
        await Swal.fire({
          text: "Não foi possível imprimir a NF-e!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn fw-bold btn-warning",
          },
        });
      }
      this.loadingPreVisualizacao = false;
    },
    async exibirModalImpressao(exibir) {
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_view_file_pdf");
        }, 100);
      } else {
        await new Promise(
          () => setTimeout(hideModalId("kt_modal_view_file_pdf"), 100),
          (this.documentoImpressao = []),
          (this.exibirImpressaoPDF = exibir)
        );
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.GerenciadorNFe.Consultar") {
            this.consultarGerenciadorNFe = true;
          }

          if (element.regra === "Permitir.GerenciadorNFe.Transmitir") {
            this.transmitirGerenciadorNFe = true;
          }

          if (element.regra === "Permitir.GerenciadorNFe.Imprimir") {
            this.imprimirGerenciadorNFe = true;
          }
        });
      }
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    this.permitirEditar = this.editar;
    this.carregarDadosNota();
    this.errosValidacao = {};
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  data() {
    return {
      imprimirGerenciadorNFe: false,
      transmitirGerenciadorNFe: false,
      consultarGerenciadorNFe: false,
      faturamento: {},
      errosValidacao: [],
      errosGerais: [],
      loading: false,
      refInutilizacaoNFe: {},
      erroOriginal: "",
      erroFormatado: "",
      mensagemLoading: "",
      loadingAcoes: false,
      exibirModalErroNFe: false,
      permitirTransmissao: false,
      permitirEditar: false,
      documentoImpressao: [],
      exibirImpressaoPDF: false,
      loadingPreVisualizacao: false,
      loadingImpressao: false,
      dadosEmail: [],
    };
  },
};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #00000042;
}
</style>
